import { Div, DivProps, List, ListItem, P } from '@kizi/core-components';
import {
  Accordion,
  AccordionProps,
  IconV2 as Icon,
} from '@kizi/shared-components';
import * as React from 'react';
import { Field } from './Product';

const accordionItemLabel = (label: string) => (isOpen: boolean) =>
  (
    <P
      fontSize={[3, 4]}
      fontWeight={1}
      display="flex"
      justifyContent="space-between"
      css={{ cursor: 'pointer' }}
    >
      {label}
      <Icon
        ml="auto"
        name={`big-arrow-${isOpen ? 'up' : 'down'}`}
        height={16}
        width={16}
      />
    </P>
  );

export interface ModalAccordionProps extends Omit<AccordionProps, 'items'> {
  title: string;
  fields: Field[];
  separator?: boolean;
  accordionInnerListVariant?: string;
  collapseOnClick?: boolean;
  allAreOpen?: boolean;
}

export const ListItemInner = (props: DivProps) => {
  return <Div flexGrow={1} flexBasis={0} {...props} />;
};

export const ModalAccordion = ({
  title,
  fields,
  accordionInnerListVariant = 'primary',
  collapseOnClick = true,
  ...restProps
}: ModalAccordionProps) => {
  return (
    <Accordion
      items={[
        {
          label: accordionItemLabel(title),
          content: (
            <List variant={accordionInnerListVariant}>
              {fields.map(({ icon, label, value }: Field, key: number) => {
                let rightFieldContent = value;

                if (icon) {
                  rightFieldContent = (
                    <Icon height={16} name={icon} width={16} />
                  );
                }

                return (
                  <ListItem key={`list-item-${label}-${value}-${key}`}>
                    <ListItemInner fontWeight={[1, 0]} mb={[1, 0]}>
                      {label}
                    </ListItemInner>
                    <ListItemInner display="flex" my="auto">
                      {rightFieldContent}
                    </ListItemInner>
                  </ListItem>
                );
              })}
            </List>
          ),
        },
      ]}
      collapseOnChildClick={collapseOnClick}
      variant="accordionPrimary"
      {...restProps}
    />
  );
};

interface ModalAccordionsProps {
  groups: ModalAccordionProps[];
  collapseOnClick?: boolean;
  allAreOpen?: boolean;
}

export const ModalAccordions = ({
  groups,
  collapseOnClick = true,
  ...rest
}: ModalAccordionsProps) => {
  return (
    <>
      {groups.map((group: ModalAccordionProps, key: number) => {
        return (
          <ModalAccordion
            {...group}
            {...rest}
            key={`modal-accordion-${key}`}
            collapseOnClick={collapseOnClick}
          />
        );
      })}
    </>
  );
};
